import { render, staticRenderFns } from "./addrelationType.vue?vue&type=template&id=4d57ba23&"
import script from "./addrelationType.vue?vue&type=script&lang=js&"
export * from "./addrelationType.vue?vue&type=script&lang=js&"
import style0 from "./addrelationType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d57ba23')) {
      api.createRecord('4d57ba23', component.options)
    } else {
      api.reload('4d57ba23', component.options)
    }
    module.hot.accept("./addrelationType.vue?vue&type=template&id=4d57ba23&", function () {
      api.rerender('4d57ba23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/components/addrelationType.vue"
export default component.exports